import { Gallerie } from "@/src/data/types";
import { useEffect, useState } from "react";
import { getAllGalleries } from "../../API/Mediatheque/Gallerie/gallerieService";
import usineImg from "../../images/Usine de Louveciennes/©Antoine_Meyssonnier-4534.jpg";
import usineImg1 from "../../images/Usine de Louveciennes/©Antoine_Meyssonnier-4535.jpg";
import usineImg2 from "../../images/Usine de Louveciennes/©Antoine_Meyssonnier-4708.jpg";
import usingImg3 from "../../images/Usine de Louveciennes/IMG_E3034.jpg";
import usingImg4 from "../../images/Usine de Louveciennes/IMG_E3035.jpg";

import forageImg from "../../images/forage.jpg";
import pompageImg1 from "../../images/Station de pomage/LUD_2030.jpg";
import pompageImg2 from "../../images/Station de pomage/LUD_2032.jpg";

import chateauImg1 from "../../images/Chateau d'eau.jpg";
import chateauImg2 from "../../images/66.png";
import chateauImg3 from "../../images/778.png";

import img from "../../images/©Antoine_Meyssonnier-4535.png";
import slid1 from "../../images/slid1.png";
import slid2 from "../../images/slid2.png";
import slid3 from "../../images/slid3.png";
import slid4 from "../../images/slid4.png";
import "../../style/carouselPerView.css";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
const PatrimoinePhoto = () => {
  let slides = [];
  const params = new URLSearchParams(window.location.search);
  const name: any = params.get("name");
  const decodedName = decodeURIComponent(name);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const [galleries, setGalleries] = useState<Gallerie[]>([]);
  const fetchData = async () => {
    const response = await getAllGalleries();
    setGalleries(response?.galleries);
  };
  useEffect(() => {
    fetchData();
  }, []);

  if (decodedName === "L'USINE DE LOUVECIENNES") {
    slides = [
      {
        id: "1",
        image: usineImg,
      },
      { id: "2", image: usineImg1 },
      { id: "3", image: usineImg2 },
      { id: "4", image: usingImg3 },
      { id: "5", image: usingImg4 },
    ];
  } else if (decodedName === "FORAGES") {
    slides = [
      {
        id: "1",
        image: forageImg,
      },
      { id: "2", image: forageImg },
      { id: "3", image: forageImg },
      { id: "4", image: forageImg },
    ];
  } else if (decodedName === "STATION DE POMPAGE") {
    slides = [
      {
        id: "1",
        image: pompageImg1,
      },
      { id: "2", image: pompageImg2 },
      { id: "3", image: pompageImg1 },
      { id: "4", image: pompageImg2 },
    ];
  } else if (decodedName === "CHÂTEAUX D’EAU ET BASSINS DE STOCKAGE") {
    slides = [
      {
        id: "1",
        image: chateauImg1,
      },
      { id: "2", image: chateauImg2 },
      { id: "3", image: chateauImg3 },
      { id: "4", image: chateauImg1 },
    ];
  } else {
    slides = [
      {
        id: "1",
        image: slid1,
      },
      { id: "2", image: slid2 },
      { id: "3", image: slid3 },
      { id: "4", image: slid4 },
    ];
  }
  return (
    <div className=" mb-52">
      <div className="">
        <section
          className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
            {"Nos Equipements  "}
          </h1>
        </section>
      </div>

      <div className="">
        <h1 className="container mx-auto mt-20 mb-20 text-4xl font-bold text-center text-black uppercase md:px-40 sm:px-40">
          {decodedName}
        </h1>
        {decodedName === "L'USINE DE LOUVECIENNES" && (
          <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
            <p className="text-justify">
              {" "}
              L’usine de Louveciennes peut traiter quotidiennement jusqu’à 120
              000 m³ d’eau.
            </p>
            <p className="mt-4 text-justify">
              {" "}
              Pour cela, elle utilise les technologies qui assurent
              l’élimination des germes et des micropollutions organiques.{" "}
            </p>
            <p className="mt-4 text-justify">
              L’eau produite est conforme aux normes de potabilité et de très
              bonne qualité organoleptique (odeur, saveur).
            </p>
            <p className="mt-4 text-justify">
              Ses caractéristiques sont contrôlées régulièrement et
              systématiquement.
            </p>
            <p className="mt-4 text-justify">
              L&#39;usine est entièrement automatisée, avec une surveillance
              humaine. Les informations sont données par différents capteurs à
              des automates programmables qui sont capables de traiter les
              informations ou alarmes dans la salle de contrôle centralisée.
            </p>
          </div>
        )}

        {decodedName === "FORAGES" && (
          <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
            <p className="text-justify">
              {" "}
              L’eau brute destinée à la consommation humaine est prélevée dans
              une nappe d’eau souterraine, appelée le champ captant. Cette nappe
              est située à Croissy-sur-Seine, dans la craie fissurée, sous les
              alluvions de la Seine.
            </p>
            <p className="mt-4 text-justify">
              {" "}
              Le captage de l’eau se fait grâce à{" "}
              <span className="font-bold">11 forages</span> , de 30 à 60 mètres
              de profondeur. Elle est ensuite acheminée à l’usine de
              Louveciennes.
            </p>
            <p className="mt-4 text-justify">
              Pour compenser la déclivité du terrain, des stations de pompage
              sont nécessaires au transport de l’eau brute. Une station de
              pompage est installée à Bougival pour relever l’eau brute sur un
              dénivelé de 150 mètres, à un débit maximum de 5 000 m³/h. Elle est
              équipée de 5 groupes électropompes.
            </p>
          </div>
        )}

        {decodedName === "STATION DE POMPAGE" && (
          <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
            <p className="text-justify">
              {" "}
              Pour compenser la déclivité du terrain, des stations de pompage
              sont nécessaires au transport de l’eau brute. Une station de
              pompage est installée à Bougival pour relever l’eau brute sur un
              dénivelé de 150 mètres, à un débit maximum de 5 000 m³/h. Elle est
              équipée de 5 groupes électropompes.
            </p>
          </div>
        )}

        {decodedName === "CHÂTEAUX D’EAU ET BASSINS DE STOCKAGE" && (
          <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
            <p className="text-justify">
              {" "}
              La distribution de l’eau potable nécessite de nombreuses
              installations de stockage :
            </p>
            <p className="mt-2 text-justify">
              <ul className="list-disc">
                <li className="text-justify">
                  Bassins de stockage pour l’eau brute : le bassin des Deux
                  Portes à Marly-le-Roi, les bassins de Louveciennes ;
                </li>
                <li className="text-justify">
                  31 châteaux d’eaux et réservoirs enterrés pour la distribution
                  de l’eau potable, en sortie de l’
                  <span className="text-primary">usine de Louveciennes.</span>
                </li>
              </ul>
            </p>
          </div>
        )}

        <div className="flex justify-center w-full mt-2 space-x-3 ">
          <Carousel
            opts={{ align: "start", loop: true }}
            className="w-full"
            slides={slides.map((slide) => slide.image)}
          >
            <div className="flex justify-end mr-14">
              <CarouselNext className="relative text-black hover:bg-primary bg-neutral-100 hover:text-white" />
              <CarouselPrevious className="relative text-black hover:bg-primary bg-neutral-100 hover:text-white" />
            </div>
            <CarouselContent>
              {slides.map((slide, index) => (
                <CarouselItem
                  key={slide.id}
                  className="basis-auto"
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <img
                    src={slide.image}
                    alt={`Slide ${slide.id}`}
                    className={`transform ${
                      decodedName === "L'USINE DE LOUVECIENNES" ||
                      decodedName === "STATION DE POMPAGE" ||
                      decodedName === "FORAGES"
                        ? "w-[450px] h-96"
                        : "w-full h-full"
                    } ${
                      hoveredIndex === index ? "scale-110 z-30" : "z-0"
                    } transition-all duration-300 ${
                      hoveredIndex === null || hoveredIndex === index
                        ? "opacity-100"
                        : "opacity-10"
                    }`}
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default PatrimoinePhoto;
